// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2X1h3","boxTitle":"Qualiphy_boxTitle__3T_ZL","box":"Qualiphy_box__RlE89","toggleWrap":"Qualiphy_toggleWrap__1ZAZd"};